import SettingTypes from '@/utils/setting-types'
import { platformType } from '@/utils/decor-types'

export default {
  name: 'book-information',
  label: {
    title: '书香资讯',
    icon: require('@/assets/icon-component-label_BookInformation.svg'),
    limit: -1,
    show: () => Number(platformType) === 1
  },
  sort: 103,
  data: {
    information: [],
    show_type: 'small'
  },
  settings: {
    information: {
      type: SettingTypes.custom,
      component_name: 'BookInformationSelector'
    },
    show_type: {
      type: SettingTypes.radio_button,
      label: '显示模式',
      options: [
        { label: '小图模式', value: 'small' },
        { label: '大图模式', value: 'banner' }
      ]
    }
  }
}
